import * as Sentry from '@sentry/react';
import React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';
import { Environment } from '@src/environment';

let isSentryEnabled = true;

export const switchSentry = (enabled: boolean) => {
  isSentryEnabled = enabled;
};

export const initSentry = (enabled: boolean) => {
  switchSentry(enabled);
  Sentry.init({
    dsn: Environment.SENTRY_DSN,
    integrations: [
      Sentry.replayIntegration(),
      Sentry.captureConsoleIntegration({
        levels: ['warn', 'error', 'assert'],
      }),
      Sentry.httpClientIntegration(),
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    environment: Environment.ENVIRONMENT,
    // comment in the next line if you want to see Sentry logs in the console
    //debug: !Environment.PROD,
    release: Environment.SENTRY_RELEASE,
    dist: 'release',
    tracesSampleRate: Environment.PROD ? 0.1 : 1.0,
    // For Distributed Tracing
    tracePropagationTargets: ['localhost:5173'],
    // Session Replay
    replaysSessionSampleRate: Environment.PROD ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,
    enabled: true,
    beforeSend(event) {
      if (isSentryEnabled) {
        return event;
      }

      return null;
    },
    beforeBreadcrumb(breadcrumb) {
      if (isSentryEnabled) {
        return breadcrumb;
      }

      return null;
    },
    beforeSendTransaction(transaction) {
      if (isSentryEnabled) {
        return transaction;
      }

      return null;
    },
  });
};
